import type {
  ProductDetailsStoryblok,
  RichtextStoryblok,
} from '../../../types/generated-storyblok';

type ProductDetailsWithLegacyCustomDimensions = ProductDetailsStoryblok & {
  /** Legacy top-level field retained on published stories after the schema move. */
  customDimensions?: RichtextStoryblok;
};

/**
 * Resolves custom dimensions from the nested productDimensions blok,
 * falling back to the legacy top-level productDetails.customDimensions field.
 */
export const getCustomDimensions = (
  productDetails: ProductDetailsWithLegacyCustomDimensions | null | undefined,
): RichtextStoryblok | undefined =>
  productDetails?.dimensions?.[0]?.customDimensions ??
  productDetails?.customDimensions;
